export default __webpack_public_path__ + "static/media/login.74526031.svg";